import React from 'react'

const HeavyHelp = () => (
  <p>Arquivo deve ter menos de 10 MB.</p>
)

export default HeavyHelp
